<template>
    <div class="theme-container" :style="textFontStyle">
        <nav class="navbar navbar-expand-lg"
             :style="navStyle(theme.nav)">
            <div class="container-fluid d-flex justify-content-between">
                <div class="navbar-brand" :style="navColor(theme.nav)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="w-10 h-10">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"/>
                    </svg>
                </div>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mb-2 mb-lg-0 w-100">
                        <li class="nav-item">
                            <a class="nav-link" :style="navColor(theme.nav)" aria-current="page" href="#">Products</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :style="navColor(theme.nav)" href="#">Solutions</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :style="navColor(theme.nav)" href="#">Pricing</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :style="navColor(theme.nav)" href="#">Company</a>
                        </li>
                        <li class="nav-item d-block d-md-none">
                            <a class="nav-link" :style="navColor(theme.nav)" href="#">Sign In</a>
                        </li>
                    </ul>
                </div>
<!--                <div class="d-none d-md-block">-->
<!--                    <button :style="primaryButtonStyle" class="btn btn-primary-theme btn-sm me-1">Sign up</button>-->
<!--                    <button :style="secondaryButtonStyle" class="btn btn-secondary-theme btn-sm">Log in</button>-->
<!--                </div>-->
            </div>
        </nav>

        <div class="p-5 page-section d-flex flex-column justify-content-center align-items-center"
             :style="backgroundStyle(theme.primary_background)">
            <h1 :style="headerFontStyle">Build Something Beautiful</h1>
            <div class="my-3 font-md">Life is too short to not appreciate beauty and craftsmanship.</div>

            <div class="d-flex">
                <button class="btn btn-primary-theme-temp btn-lg me-1" :style="primaryButtonStyle" :class="primaryButtonClasses">Get Started</button>
                <button class="btn btn-secondary-theme-temp btn-lg ms-1" :style="secondaryButtonStyle">Learn More</button>
            </div>

            <div class="mt-4">
                <a href="javascript:void(0)" class="theme-link" :style="linkStyle">Link to No Where</a>
            </div>
        </div>

        <div class="d-flex flex-column align-items-center" :style="backgroundStyle(theme.secondary_background)">
            <h2 class="pt-5" :style="headerFontStyle">Hand-crafted design... for everyone!</h2>

            <div class="py-5 container">
                <div class="row">
                    <div class="col-sm-12 col-md-3">
                        <div class="theme-card-temp mx-2 my-1 h-100-pct" :style="cardStyle">
                            <div class="card-body">
                                <h5 class="card-title">Beauty is in</h5>
                                <p class="card-text">Everyone deserves a beautiful website and application. This is
                                    table stakes with WeBase.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <div class="theme-card-temp mx-2 my-1 h-100-pct" :style="cardStyle">
                            <div class="card-body">
                                <h5 class="card-title my-2">Beauty is in</h5>
                                <p class="card-text">Everyone deserves a beautiful website and application. This is
                                    table stakes with WeBase.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <div class="theme-card-temp mx-2 my-1 h-100-pct" :style="cardStyle">
                            <div class="card-body">
                                <h5 class="card-title">Beauty is in</h5>
                                <p class="card-text">Everyone deserves a beautiful website and application. This is
                                    table stakes with WeBase.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <div class="theme-card-temp mx-2 my-1 h-100-pct" :style="cardStyle">
                            <div class="card-body">
                                <h5 class="card-title my-2">Beauty is in</h5>
                                <p class="card-text">Everyone deserves a beautiful website and application. This is
                                    table stakes with WeBase.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'ExampleThemeContent',
    props: ['theme'],
    data () {
        return {
            model: webase.model
        }
    },
    computed: {

        linkStyle() {
            return {
                'color': this.theme.primary_background.color, // using the color of the container link is in
                'text-decoration': this.theme.link.underline ? 'underline' : 'none'
            }
        },

        cardStyle() {
            let style = {
                '--bs-card-border-color': this.theme.card.border_color,
                '--bs-card-color': this.theme.card.color,
                '--bs-card-bg': this.theme.card.background_color,
            }

            if(this.theme.card.show_box_shadow) {
                style['box-shadow'] = `0px 4px 20px ${this.theme.card.box_shadow_color}`
            }

            return style
        },

        primaryButtonStyle() {
            return this.buttonStyle(this.theme.primary_button)

            // box-shadow: 12px 12px 2px 1px rgba(0, 0, 255, .2);
            // 2px 2px 0 0 #000, inset 0 0 0 2px #000;
            //style['box-shadow'] = `60px -16px teal`
        },

        secondaryButtonStyle() {
            return this.buttonStyle(this.theme.secondary_button)
        },

        primaryButtonClasses() {
            return this.buttonClasses(this.theme.primary_button)
        },

        secondaryButtonClasses() {
            return this.buttonClasses(this.theme.secondary_button)
        },

        textFontStyle() {
            let weight = this.theme.text_font.weight

            let fontStyle = {
                fontFamily: this.theme.text_font.family,
                fontWeight: weight === 'regular' ? '400' : weight,
            }

            return fontStyle
        },

        headerFontStyle() {
            let weight = this.theme.header_font.weight

            let fontStyle = {
                fontFamily: this.theme.header_font.family,
                fontWeight: weight === 'regular' ? '400' : weight,
            }

            return fontStyle
        },
    },
    mounted () {
    },
    methods: {
        buttonStyle(buttonObject) {
            return {
                '--bs-btn-color': buttonObject.color,
                '--bs-btn-bg': buttonObject.background_color,
                '--bs-btn-hover-bg': buttonObject.hover_color,
                '--bs-btn-border-color': buttonObject.border_color,
                '--bs-btn-hover-color': buttonObject.color, // Hack to ensure color isn't changed on hover.  Add to data model?
                '--bs-btn-hover-border-color': buttonObject.hover_border_color,
                '--bs-btn-box-shadow': buttonObject.box_shadow,
                '--bs-btn-border-radius' : this.getBorderRadiusValue(buttonObject.style)
            }
        },

        getBorderRadiusValue(buttonCornerStyle) {
            if(buttonCornerStyle === 'square') {
                return '0'
            }
            else if(buttonCornerStyle === 'pill') {
                return '50rem'
            }
            else {
                return '0.5rem'
            }
        },

        buttonClasses(buttonObject) {
            if(buttonObject.include_hover_effect) {
                if(buttonObject.hover_effect === 'float') {
                    return 'btn-float-effect'
                }

                if(buttonObject.hover_effect === 'bulge') {
                    return 'btn-bulge-effect'
                }
            }

            return ''
        },

        navStyle(navObject) {
            return {
                backgroundColor: navObject.background_color
            }
        },

        navColor(navObject) {
            return {
                'color': navObject.color
            }
        },

        backgroundStyle(backgroundObject) {
            if (backgroundObject.type === 'linear gradient') {
                return {
                    background: this.linearGradient(backgroundObject),
                    color: backgroundObject.color
                }
            } else if (backgroundObject.type === 'radial gradient') {
                return {
                    background: this.radialGradient(backgroundObject),
                    color: backgroundObject.color
                }
            }

            return {
                backgroundColor: backgroundObject.background_color,
                color: backgroundObject.color
            }
        },
        linearGradient(background) {
            let color1 = background.background_color
            let color2 = background.background_color2
            return `linear-gradient(to right, ${color1}, ${color2})`;
        },
        radialGradient(background) {
            let color1 = background.background_color
            let color2 = background.background_color2
            return `radial-gradient(circle at center, ${color1}, ${color2})`;
        }
    }
}
</script>

<style>

</style>
